var addCommasToSalary = function addCommasToSalary(salary) {
  return salary && salary.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}; // IE11 does not support isInteger so providing a fallback


Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && // eslint-disable-next-line no-restricted-globals
  isFinite(value) && Math.floor(value) === value;
};

var formatDecimals = function formatDecimals(_ref, value) {
  var symbol = _ref.symbol;
  if (!Number.isInteger(value)) return symbol + value.toFixed(2);
  return symbol + value;
};

var formatRange = function formatRange(salary) {
  var minimum = salary.minimum,
      maximum = salary.maximum,
      currency = salary.currency;
  var value = '';

  if (minimum && maximum && minimum !== maximum) {
    value = "".concat(formatDecimals(currency, minimum), " - ").concat(formatDecimals(currency, maximum));
    return addCommasToSalary(value);
  }

  if (minimum || maximum) {
    value = "".concat(formatDecimals(currency, minimum || maximum));
    return addCommasToSalary(value);
  }

  return null;
};

var formatFrequency = function formatFrequency(frequency) {
  if (!frequency) return undefined;
  return frequency.indexOf('rata') === -1 ? "per ".concat(frequency) : frequency;
};

export var buildSalaryObject = function buildSalaryObject(_ref2) {
  var _ref2$salary = _ref2.salary,
      salary = _ref2$salary === void 0 ? {} : _ref2$salary,
      displaySalary = _ref2.displaySalary;
  if (!salary) return {
    description: displaySalary
  }; // if no salary was populated in portal a null is stored instead thus this check is required

  var description = salary.description,
      currency = salary.currency,
      frequency = salary.frequency;
  var salaryDetails = {
    description: description || displaySalary,
    currency: currency,
    range: formatRange(salary),
    period: formatFrequency(frequency)
  };
  return salaryDetails;
};